<template>
    <div class="mobileBankAccountingList">
        <div class="top">
            <el-date-picker
                size="medium"
                type="date"
                value-format="yyyy-MM-dd"
                :clearable="false"
                v-model="createDate"
                @change="getList"
            ></el-date-picker>
            <el-select size="medium" @change="getList()" v-model="clientType" placeholder="请选择">
                <el-option :key="0" label="全部来源" :value="0"></el-option>
                <el-option :key="value" :label="label" :value="value" v-for="[value, label] in clientTypeConstants"></el-option>
            </el-select>
            <a
                :href="exportUrl"
                target="_blank"
                download="activityName"
            >
                <el-button
                    type="primary"
                    size="medium"
                >导出
                </el-button>
            </a>
            <el-input size="medium" class="search-input search-input--right" placeholder="学校名称/id"
                      v-model="schoolName" @keyup.enter.native="handleCurrentChange(1)">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="handleCurrentChange(1)"></el-button>
            </el-input>
        </div>
        <el-table
            stripe
            :data="dataList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="id"
                align="center"
                prop="schoolId"
                width="100px"
            >
            </el-table-column>
            <el-table-column
                label="学校名称"
                align="center"
                show-overflow-tooltip
                prop="schoolName"
            >
            </el-table-column>
            <el-table-column
                label="区域"
                align="center"
                show-overflow-tooltip
                prop="orgAreaName"
            >
            </el-table-column>
            <el-table-column
                label="所属支行"
                align="center"
                show-overflow-tooltip
                prop="subBranch"
            >
            </el-table-column>
            <el-table-column
                label="人数"
                align="center"
                prop="userCount"
            ></el-table-column>
            <el-table-column
                label="已上报"
                align="center"
                prop="reportCount"
            ></el-table-column>
            <el-table-column
                label="未上报"
                align="center"
                prop="notReportCount"
            >
                <template slot-scope="scope">
                    {{scope.row.userCount - scope.row.reportCount}}
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10,20,30, 50]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {clientTypeConstants} from '@/utils/constants';
    import BackTool from '@/components/BackTool';
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from "@/mixins/baseMixin.js";

    import {getExportUrl, parseToConstants} from '@/utils/utils';
    import {getDiseaseTripSchoolListByPage} from '@/api/dataAnalysis';

    export default {
        name: "trailRecordAccounting",
        components: {BackTool},
        mixins: [windowResize, baseMixin],
        computed: {
            exportUrl() {
                return getExportUrl('wxcepClient1/structure/diseaseTrip/exportDiseaseTripSchoolListAll', {
                    clientType: this.clientType,
                    createDate: this.createDate,
                    schoolName: this.schoolName
                });
            }
        },
        data() {
            return {
                clientTypeConstants,
                createDate: moment().format('YYYY-MM-DD'),
                clientType: 0,
                dataList: [],
                schoolName: '',
            }
        },
        created() {
            this.getList();

        },
        methods: {
            parseToConstants,
            handleSizeChange(pageSize) {
                this.pagination.pageSize = pageSize;
                this.getList();
            },
            // 分页 - currentPage 改变
            handleCurrentChange(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getList();
            },
            getList() {
                getDiseaseTripSchoolListByPage({
                    clientType: this.clientType,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    createDate: this.createDate,
                    schoolName: this.schoolName
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data || {dataList: [], pagination: {total: 0}};
                        this.dataList = pageData.dataList;
                        this.pagination.total = pageData.pagination.total;
                    })
            }
        }
    }
</script>
<style>
    .mobileBankAccountingList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    @import "../../styles/mixin";

    .mobileBankAccountingList {
        padding: 12px;

        .top {
            padding-bottom: 10px;
        }

    }
    .link {
        color: #20a0ff;
        cursor: pointer;
    }
    .school-item {
        display: flex;
        float: left;
        align-items: center;
        width: 202px;
        height: 80px;
        margin: 10px;
        padding: 6px 10px;
        overflow: hidden;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
        transition: all .3s linear;

        .school-item__photo {
            @include cover-bg;
            width: 50px;
            height: 50px;
            margin: 10px 5px;
            margin-right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/trailRecordAccounting.vue